<template>
    <Card title="Statuts">
        <div
            v-for="(statut, index) in status"
            :key="index"
            class="flex place-content-between pr-20 mb-4"
        >
            <span
                ><p>{{ statut[0] }}</p></span
            >
            <span
                class="bg-orange-300 flex justify-center content-center rounded-full w-10 max-h-6"
                ><p>{{ statut[1] }}</p></span
            >
        </div></Card
    >
</template>

<script>
import Card from "../card";
export default {
    components: {
        Card
    },
    props: {
        status: {
            type: Map,
            required: true
        }
    }
};
</script>

<style></style>
